import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import _defineProperty from "/vercel/path1/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { DefaultSeo } from 'next-seo';
import HubLayout from '../../components/layout/hub';
import PublicationHub from '../../components/ui/publication-hub/publication-hub';
export var __N_SSG = true;
export var Hub = function Hub(props) {
  var pageTitle = "Latest publications - ".concat(props.organization.name);
  var pageDesc = "View publication of ".concat(props.organization.name);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(DefaultSeo, {
      title: pageTitle,
      description: pageDesc
    }), /*#__PURE__*/_jsx(PublicationHub, _objectSpread(_objectSpread({}, props), {}, {
      currentPage: 1
    }))]
  });
};

Hub.getLayout = function (page) {
  return /*#__PURE__*/_jsx(HubLayout, {
    children: page
  });
};

export default Hub;